module.exports = [{"text":"Pazar günü hava çok güzeldi.Gamze sabah ödev yaptı, sonra biraz kitap okudu.Sonra canı sıkıldı.O sırada kapı çaldı, Gamze çok sevindi.Hemen koştu ve kapıyı açtı.Arkadaşı Şebnem gelmişti","id":"thec_2_4","title":"Gamze ve Arkadaşı"},{"text":"İpek tatilde anne ve babasıyla birlikte kampa gitmişti.Kampta çadırda kalıyorlardı.O sabah anne ve babası uyurken İpek yine erkenden uyandı.Çadırdan dışarı çıktı.Derin derin nefes alarak temiz havayı içine çekti.","id":"thec_3_6555","title":"İpek Ormanda"}]


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/tekerlemeler/heceleme.json
// module id = tuh/
// module chunks = 4